<template>
  <table>
    <tr style="font-size: small">
      <td><span class="badge">Contratos: </span></td>
      <td>
        <span
          class="badge"
          style="
            background: white;
            color: black;
            border: 1px solid rgb(63, 62, 62);
          "
          >Activos</span
        >
      </td>
      <td>
        <span
          class="badge"
          style="
            background: #8fd3f7;
            color: black;
            border: 1px solid rgb(63, 62, 62);
          "
          >En Mant. Indefinido</span
        >
      </td>
      <td>
        <span
          class="badge"
          style="
            background: #c6e8fb;
            color: black;
            border: 1px solid rgb(63, 62, 62);
          "
          >En Mant. Definido</span
        >
      </td>
    </tr>
  </table>
</template>
<script>
import Vue from "vue";
export default Vue.extend({
  name: "referenciaDeColoresComponent",
});
</script>
